import { render, staticRenderFns } from "./left-first-content.vue?vue&type=template&id=70388ec8&scoped=true&"
import script from "./left-first-content.vue?vue&type=script&lang=js&"
export * from "./left-first-content.vue?vue&type=script&lang=js&"
import style0 from "./left-first-content.vue?vue&type=style&index=0&id=70388ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70388ec8",
  null
  
)

export default component.exports